import { Toolbar, TableButton } from '@/shared/components/MaterialTableElements';
import PlusIcon from 'mdi-react/PlusIcon';

interface MatTableToolbarProps {
    // numSelected: number;
    // handleDeleteSelected: () => void;
    onRequestAdd: () => void;
}

const MatTableToolbar = ({
    //  numSelected,
    // handleDeleteSelected,
    onRequestAdd,
}: MatTableToolbarProps) => (
    <Toolbar className="material-table__toolbar">
        {/* <div>
                {numSelected > 0 && (
                    <TableToolbarSelected>
                        {numSelected} <span>selected</span>
                    </TableToolbarSelected>
                )}
            </div> */}
        <div className="d-flex align-items-center justify-content-center" role="button" onClick={onRequestAdd}>
            {/* {numSelected > 0 ? (
                    <TableButton onClick={handleDeleteSelected}>
                        <DeleteIcon />
                    </TableButton>
                ) : ( */}
            <TableButton>
                <PlusIcon />
            </TableButton>
            <span>Add New Category</span>
            {/* )} */}
        </div>
    </Toolbar>
);

export default MatTableToolbar;
